import React from 'react'
import NikuCar from '../../assets/img/niku_car_blanco.png'
import {
  IoIosHome,
  IoMdCar,
  IoMdCheckmark,
  IoMdRedo,
  IoMdMan,
  IoIosMap,
} from 'react-icons/io'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCircleUser } from '@fortawesome/free-regular-svg-icons'
import { getAuth, signOut } from 'firebase/auth'
import { useAuth } from '../../context/AuthContext'
import useUserRole from '../../getRole'

const Sidebar = ({ setCurrentPage }) => {
  const auth = getAuth()
  const { user } = useAuth()
  const userRole = useUserRole(user)

  const handleLogout = async () => {
    const user = await auth.currentUser
    if (user) {
      try {
        await signOut(auth)
        window.location.href = '/'
      } catch (error) {
        console.error('Error al cerrar sesión:', error)
      }
    }
  }

  return (
    <div className="bg-BlueD text-white semi:w-sb h-full fixed flex flex-col justify-center items-center">
      <div className=" xl:block 2xs:hidden flex flex-col justify-end items-center">
        <header>
          <div className=" text-center text-4xl big:p-4 ">
            <img
              src={NikuCar}
              alt="NikuCar"
              className="xl:w-32 xl:h-24 mx-auto big:mt-7"
            />
            <h1 className="big:mt-10">Dashboard</h1>
          </div>
        </header>
        <div className="grid grid-flow-row-dense grid-rows-6 semi:mt-0 big:mt-20 text-2xl">
          {(userRole === 'Admin' || userRole === 'Master') && (
            <button
              className="text-white ml-4 rounded-md hover:bg-white hover:text-black text-left"
              onClick={() => setCurrentPage('Home')}
            >
              <IoIosHome className="inline-block ml-1 mb-2 w-6 h-6 mr-2" />
              Home
            </button>
          )}
          {(userRole === 'Admin' || userRole === 'Master') && (
            <button
              className="text-white ml-4 rounded-md hover:bg-white hover:text-black text-left"
              onClick={() => setCurrentPage('Conductores')}
            >
              <IoMdCar className="inline-block ml-1 mb-2 w-6 h-6 mr-2" />
              Conductores
            </button>
          )}
          {(userRole === 'Admin' ||
            userRole === 'Master' ||
            userRole === 'control') && (
            <button
              className="text-white m-4 rounded-md hover:bg-white hover:text-black text-left"
              onClick={() => setCurrentPage('ViajesEnCurso')}
            >
              <IoMdRedo className="inline-block ml-1 mb-2 w-6 h-6 mr-2" />
              Viajes En Curso
            </button>
          )}
          {(userRole === 'Admin' || userRole === 'Master') && (
            <button
              className="text-white m-4 rounded-md hover:bg-white hover:text-black text-left"
              onClick={() => setCurrentPage('ViajesFinalizados')}
            >
              <IoMdCheckmark className="inline-block ml-1 mb-2 w-6 h-6 mr-2" />
              Viajes Finalizados
            </button>
          )}
          {userRole === 'Admin' && (
            <button
              className="text-white m-4 rounded-md hover:bg-white hover:text-black text-left"
              onClick={() => setCurrentPage('Pasajeros')}
            >
              <IoMdMan className="inline-block ml-1 mb-2 w-6 h-6 mr-2" />
              Pasajeros
            </button>
          )}
          {(userRole === 'Admin' || userRole === 'Master') && (
            <button
              className="text-white m-4 rounded-md hover:bg-white hover:text-black text-left"
              onClick={() => setCurrentPage('Mapa')}
            >
              <IoIosMap className="inline-block ml-1 mb-2 w-6 h-6 mr-2" />
              Mapa
            </button>
          )}
        </div>
        <div className="flex flex-col items-center justify-center big:mt-5 bottom-0">
          <FontAwesomeIcon
            icon={faCircleUser}
            className=" h-12"
          />
          <button
            className="bg-white rounded-full text-lg p-2 aspect-w-4 aspect-h-1 text-BlueD big:mt-4 semi:mt-1 hover:text-black hover:scale-105 transition-all hover:font-bold"
            onClick={handleLogout}
          >
            Cerrar sesión
          </button>
          <button className="big:mt-7 semi:mt-3 text-xs mb-2 big:hover:scale-110 semi:hover:scale-105 hover:text-orange-500">
            NIKU TECNOLOGIA, S.A. DE C.V. v.2.0
          </button>
        </div>
      </div>
    </div>
  )
}

export default Sidebar
